// extracted by mini-css-extract-plugin
export default {"main":"L3Uppfkus4RVdp1N698zPA==","tfaOpt":"BpreJ5+XtnUZLvm2IwIcVw==","whatsappOpt":"RrhTwJOW-qSoG0D-B9NJ5g==","backToLogin":"RmEpit+U5S-5dLDB87b6Rg=="};